import { z } from 'zod';

export const clientShareLinkSchema = z.object({
  enabled: z.boolean(),
  token: z.string().nullable(),
});

export type ClientShareLinkSchema = z.infer<typeof clientShareLinkSchema>;
